import type { ItemStoreState } from "@editor/items/ItemStore";
import type { Migration } from ".";
import type { StoreItem } from "@editor/items/StoreItem";

const migration: Migration = {
  applyToVersions: "<3.1.0-beta.8",
  type: "before",
  name: "convert 'visibleIf'-options to 'hiddenIf' options",
  migrate: (data: {
    actions?: ItemStoreState<NewActionItem>;
  }) => {
    if (data.actions) {
      for (const action of Object.values(data.actions.items)) {
        if (action.visibleIfCostsNotCovered !== undefined) {
          action.hiddenIfCostsNotCovered = !action.visibleIfCostsNotCovered;
          delete action.visibleIfCostsNotCovered;
        }
        if (action.visibleIfRequirementsNotFulfilled !== undefined) {
          action.hiddenIfRequirementsNotFulfilled = !action.visibleIfRequirementsNotFulfilled;
          delete action.visibleIfRequirementsNotFulfilled;
        }
        if (action.visibleIfMaxOccurrencesReached !== undefined) {
          action.hiddenIfMaxUsesReached = !action.visibleIfMaxOccurrencesReached;
          delete action.visibleIfMaxOccurrencesReached;
        }
      }
    }
    return data;
  }
};

export default migration;

interface NewActionItem extends StoreItem {
  visibleIfCostsNotCovered?: boolean;
  hiddenIfCostsNotCovered: boolean;
  
  visibleIfRequirementsNotFulfilled?: boolean;
  hiddenIfRequirementsNotFulfilled: boolean;

  visibleIfMaxOccurrencesReached?: boolean;
  hiddenIfMaxUsesReached: boolean;
}